import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from "../auth/auth-guard.service";

import { BasicLayoutComponent } from "../../components/common/layouts/basicLayout.component";

import { ContactsComponent } from "../contacts/contacts.component";
import { ContactListComponent } from "../contacts/contact-list/contact-list.component";
import { ContactManageComponent } from "../contacts/contact-manage/contact-manage.component";

import { ContactFilesComponent } from "../contacts/contact-files/contact-files.component";
import { ContactFileListComponent } from "../contacts/contact-files/contact-file-list/contact-file-list.component";
import { ContactFileManageComponent } from "../contacts/contact-files/contact-file-manage/contact-file-manage.component";
import { ContactImportComponent } from '../contacts/contact-import/contact-import.component';

const contactsRoutes: Routes = [
  {
    path: '',
    component: BasicLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'contacts', component: ContactsComponent,
        children: [
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: 'list', component: ContactListComponent },
          { path: ':id/edit', component: ContactManageComponent },
          { path: 'new', component: ContactManageComponent },
          { path: 'new/:organizationId', component: ContactManageComponent },
          { path: 'import', component: ContactImportComponent, canActivate:[] },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(contactsRoutes)],
  exports: [RouterModule]
})
export class ContactsRoutingModule { }
